<template>
   <v-card tile>
    <v-toolbar card dark color="orange">
      <v-btn icon @click.native="fechar" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Cadastro de Parente</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn dark flat @click.native="dialog_criterios = true">Adicionar Critério</v-btn>
        <v-btn dark flat @click.native="avaliar()">Salvar Avaliação</v-btn>
        <v-btn dark flat @click.native="avaliarepublicar()">Salvar e Publicar</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>
        <v-layout row wrap v-scroll>
          <v-flex xs12 class="mx-5">
            <v-text-field
              label="Nome de usuário"
              v-model="parente.username"
              required
              :counter="30"
              maxlength="30"
              :rules="usernameRules"
              @input="doesUsernameExists"
            ></v-text-field>
            <v-text-field
              label="Nome"
              v-model="parente.first_name"
              :rules="[v => !!v || 'Nome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="Sobrenome"
              v-model="parente.last_name"
              :rules="[v => !!v || 'Sobrenome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="parente.email"
              :rules="emailRules"
              :counter="50"
              maxlength="50"
              required
            ></v-text-field>
            <v-text-field
              label="Parentesco"
              v-model="parentesco"
              required
              :rules="[v => !!v || 'Parentesco é obrigatório']"
              hint="Pai/Mãe/Tio"
            persistent-hint
            ></v-text-field>
            <v-checkbox v-model="respfinanceiro" 
            label="Responsável financeiro?" ></v-checkbox>

            <v-checkbox v-model="mesmoendereco" 
            @click.native="sameAddress" 
            label="Mesmo endereço do aluno?" ></v-checkbox>
            
            <v-menu
              ref="menu"
              lazy
              :close-on-content-click="false"
              v-model="menu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                label="Data de nascimento"
                v-model="parente.birthdate"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                ref="picker"
                v-model="parente.birthdate"
                locale="pt-br"
                min="1910-01-01"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
            <v-select
              label="Gênero"
              :items="genero"
              item-text="tipo"
              item-value="acron"
              v-model="parente.gender"
              max-height="400"
            ></v-select>
            <v-text-field
            label="RG"
            v-model="parente.rg"
            mask="##.###.###-#"
          ></v-text-field>
          <v-text-field
            label="Orgão emissor"
            v-model="parente.orgaoemissor"
          ></v-text-field>
          <v-text-field
            label="Estado de emissão"
            v-model="parente.estadoemissor"
            mask="AA"
          ></v-text-field>
          <v-text-field v-if="!respfinanceiro"
            label="CPF"
            mask="###.###.###-##"
            v-model="parente.cpf"
          ></v-text-field>
          <v-text-field v-if="respfinanceiro"
            label="CPF"
            mask="###.###.###-##"
            v-model="parente.cpf"
            required
          ></v-text-field>
          <v-text-field
            label="Telefone"
            v-model="phonenumber"
            mask="(##) #####-####"
          ></v-text-field>
          <v-text-field v-if="!mesmoendereco"
            label="CEP"
            v-model="parente.cep"
            mask="#####-###"
          ></v-text-field>
          <v-text-field v-if="!mesmoendereco"
            label="Logradouro"
            v-model="parente.logradouro"
            :counter="100"
            maxlength="100"
          ></v-text-field>
          <v-text-field v-if="!mesmoendereco"
            label="Número"
            v-model="parente.numero"
            :counter="10"
            maxlength="10"
          ></v-text-field> 
          <v-text-field v-if="!mesmoendereco"
            label="Complemento"
            v-model="parente.complemento"
          ></v-text-field>
          <v-text-field v-if="!mesmoendereco"
            label="Bairro"
            v-model="parente.bairro"
          ></v-text-field> 
          <v-text-field v-if="!mesmoendereco"
            label="Cidade"
            v-model="parente.cidade"
            :counter="50"
            maxlength="50"
          ></v-text-field>
          <v-text-field v-if="!mesmoendereco"
            label="Estado"
            v-model="parente.estado"
            mask="AA"
          ></v-text-field> 
          </v-flex>
           <v-btn color="primary"  @click.native="proximo" >Salvar</v-btn>
        </v-layout>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  props: [
    'step2Data',
    'step1Data'
  ],
  data () {
    return {
      parente: {
        role: 'Parente',
        groups: ['Parente'],
        unidade: []
      },
      menu: false,
      info: {
        parente: {},
        parentesco: '',
        respfinanceiro: false,
        phonenumber: ''
      },
      mesmoendereco: false,
      respfinanceiro: false,
      phonenumber: '',
      usernameExists: false,
      valid: true,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => this.validemail(v)
      ],
      usernameRules: [
        v => !!v || 'Nome de usuário é obrigatório',
        v => !this.usernameExists || 'Username já existe',
        v => this.validuser(v)
      ],
      genero: [
            {acron: 'F', tipo: 'Feminino'},
            {acron: 'M', tipo: 'Masculino'},
            {acron: 'O', tipo: 'Outro'}
      ]
    }
  },
  mounted () {

  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  beforeDestroy () {
    console.log(this.parente)
  },
  methods: {
    sameAddress () {
      if (this.mesmoendereco) {
        this.parente.cep = this.step2Data.cep
        this.parente.logradouro = this.step2Data.logradouro
        this.parente.numero = this.step2Data.numero
        this.parente.complemento = this.step2Data.complemento
        this.parente.bairro = this.step2Data.bairro
        this.parente.cidade = this.step2Data.cidade
        this.parente.estado = this.step2Data.estado
      }
    },
    validemail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'E-mail inválido'
    },
    validuser (value) {
      const pattern = /^([A-Za-z@.+\-_]+)$/
      return pattern.test(value) || 'Este campo pode conter apenas letras, números e os seguintes caracteres @ . + - _ .'
    },
    doesUsernameExists () {
      var self = this
      api.request('GET', 'search-user?username=' + this.parente.username)
        .then(resp => {
          if (resp.data.length >= 1) {
            self.usernameExists = true
          } else {
            self.usernameExists = false
          }
        })
    },
    save (date) {
      this.$refs.menu2.save(date)
    },
    proximo () {
      if (this.$refs.form.validate()) {
        this.parente.unidade = this.step1Data.unidade
        this.info.parente = this.parente
        this.info.parentesco = this.parentesco
        this.info.respfinanceiro = this.respfinanceiro
        this.info.phonenumber = this.phonenumber
        this.$emit('parenteDados', this.info)
        this.respfinanceiro = false
        this.mesmoendereco = false
        this.parente = {}
        this.info = {}
        this.parentesco = ''
        this.phonenumber = ''
        this.$emit('close')
      }
    },
    fechar () {
      this.respfinanceiro = false
      this.mesmoendereco = false
      this.parente = {}
      this.info = {}
      this.parentesco = ''
      this.phonenumber = ''
      this.$emit('close')
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>
<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reusable/CadastroParente.vue